export const defaultEventsTableRowHeight = 40;
export const maxResultsLimitToDisplay = 50;
